var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar-container",on:{"click":_vm.onClickUserAvatar}},[_c('div',{staticClass:"avatar",style:({width: _vm.SizeValue, height: _vm.SizeValue})},[_c('img',{attrs:{"src":_vm.getAvatarUrl(_vm.userInfo)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }